import { useARC } from "providers/ARC/ARCProvider";
import { useTranslation } from "react-i18next";
import { useFeatures } from "providers/FeaturesProvider";
import { useGimbalControl } from "providers/GimbalControlProvider";
import { useArmControl } from "providers/ArmControlProvider";

import FunctionalButton from "components/layout/FunctionalButton";

import { ReactComponent as ControlGimbalIcon } from "assets/svgs/ControlGimbal.svg";

import { ConnectionState } from "lib/consts/ARC/connection";

const ControlGimbalButton = () => {
    const { t } = useTranslation("control");
    const { connectionState } = useARC();
    const { hasGimbalControl } = useFeatures();
    const { controlGimbal, setControlGimbal } = useGimbalControl();
    const { controlArm, setControlArm, sendArmCmdVelZero } = useArmControl();

    const isConnectedToARC = connectionState === ConnectionState.Connected;
    const isEnabled = isConnectedToARC && hasGimbalControl;

    // Only render if gimbal control is available
    if (!hasGimbalControl) {
        return null;
    }

    const onClick = () => {
        const next = !controlGimbal;
        if (next && controlArm) {
            sendArmCmdVelZero();
            setControlArm(false);
        }
        setControlGimbal(next);
    };

    return (
        <FunctionalButton
            className={`control-button-type3 ${controlGimbal && "control-button-active"} ${!isEnabled && "control-button-disable"
                }`}
            icon={
                <ControlGimbalIcon
                    className={`w-6 ${!isEnabled && "text-black70"}`}
                />
            }
            hoverText={t("buttons.controlGimbal")}
            disabled={!isEnabled}
            onClick={onClick}
        />
    );
};

export default ControlGimbalButton;
